import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_projects_by_projectCodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectCode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectCode)) {
      missingRequiredInParams.push('\'projectCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectCode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectCode)) {
      missingRequiredInParams.push('\'projectCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectCode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectCode)) {
      missingRequiredInParams.push('\'projectCode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectCode: string    }) {
        if(isNil(inParams.projectCode)) {
          return true; 
        }
      return false;
    }
}
